import gql from 'graphql-tag';

export const UPSERT_EQUIPMENT_RECORD = gql`
  mutation UpsertEquipmentRecord($input: UpsertEquipmentInput!) {
    equipment {
      upsertEquipmentRecord(input: $input) {
        success
        error
        entity {
          equipmentId
        }
      }
    }
  }
`;
